import { configure } from 'mobx';
import { EnvironmentVariables } from './environmentStore';
import { GlobalStore } from './globalStore';
import { MeetCapabilitiesStore } from './meetCapabilitiesStore';
import { MeetPresenceStore } from './meetPresenceStore';
import { _BaseStore } from './_baseStore';
import { WorkerStore } from './workerStore';

export abstract class BaseStore extends _BaseStore {
  globalStore: GlobalStore;
  workerStore: WorkerStore;
  /*
   * Here and not on _BaseStore, which service.ts imports directly: this store holds a CallService,
   * and that branch is evaluated before service.ts has defined Service. See MeetCapabilitiesStore.
   *
   * Constructed empty and not loaded -- this runs before anyone has signed in, and the request
   * needs a session. useMeetCapabilities asks for it from a component, which by definition is after.
   */
  meetCapabilitiesStore: MeetCapabilitiesStore;
  /** Here for the same reason, and holding a CallService for the same reason. */
  meetPresenceStore: MeetPresenceStore;

  constructor(routeBasePath: string, routeBaseUrl: string, environmentVariables: EnvironmentVariables) {
    super(environmentVariables);
    this.globalStore = new GlobalStore(routeBasePath, routeBaseUrl);
    this.meetCapabilitiesStore = new MeetCapabilitiesStore();
    this.meetPresenceStore = new MeetPresenceStore();
    this.workerStore = new WorkerStore();
  }
}

configure({
  enforceActions: 'never',
});
